import React, { ReactElement } from "react";
import styles from "./SecondaryButton.module.scss";
import { Button, SemanticSIZES } from "semantic-ui-react";

type Props = {
  text?: string | ReactElement;
  children?: string | ReactElement;
  role?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  size?: SemanticSIZES;
};

const SecondaryButton: React.FC<Props> = ({
  text,
  children,
  role = "button",
  onClick,
  size,
}) => {
  return (
    <Button
      onClick={onClick}
      fluid
      secondary
      className={styles.self}
      role={role}
      size={size}
    >
      {text || children}
    </Button>
  );
};

export default SecondaryButton;
